import axios from 'axios'

export default {
    namespaced: true,
    state: {
        vod_cname: null,
        live_cname: null,
        account_id: '',
    },

    mutations: {
        SET_VOD(state, vod_cname){
            state.vod_cname = vod_cname;
        },
        SET_LIVE(state, live_cname){
            state.live_cname = live_cname;
        }
    },
    actions: {
        async getCname({ commit, rootState }, account_id) {

            const apiPreUrl = rootState.url.apiPreUrl;
            const fronUrl = rootState.url.frontPreUrl;

            try {
                const params = {
                    account_id: account_id,
                    ip: fronUrl
                };
                const response = await axios.get(apiPreUrl + `/api/cname-info`, {
                    params,
                });
                // console.log('res', response.data);
                sessionStorage.setItem('vod_cname', response.data.vod_cname);
                sessionStorage.setItem('live_cname', response.data.live_cname);
                commit('SET_VOD', response.data.vod_cname);
                commit('SET_LIVE', response.data.live_cname);
                return response.data;
            } catch (error){
                console.log(error);
            }
        },
    },

    getters: {
        vod_cname: state => state.vod_cname,
        live_cname: state => state.live_cname
    }
}